import { createFeatureSelector, createSelector } from '@ngrx/store';

import { segmentFeatureKey } from '../segment-feature-key';
import { SegmentState } from '../reducers';

const segmentState = createFeatureSelector<SegmentState>(segmentFeatureKey);

export const isSegmentEnabled = createSelector(segmentState, (state) => state.isSegmentEnabled);
